module.exports = __webpack_public_path__ + "img/pendente-struve.70ccec53.jpg";